/* eslint-disable no-param-reassign */

const slider = () => {
  const sliders = document.querySelectorAll('.js-slider');
  sliders.forEach(container => {
    const pager = container.parentElement.querySelector('.js-slider-pager');
    const sliderItems = container.querySelectorAll('.js-slider-item');
    let xDown = null;
    let yDown = null;
    if (!container.classList.contains('js-clone-disabled')) {
      if (sliderItems[0]) {
        const cloneItem = sliderItems[0].cloneNode(true);
        cloneItem.classList.remove('is-active');
        cloneItem.classList.add('clone-item');
        [...sliderItems].pop().after(cloneItem);
      }
    }

    if (pager) {
      pager.querySelectorAll('.js-slider-pager-item').forEach(page => {
        page.addEventListener('click', e => {
          container.parentElement
            .querySelectorAll('.js-slider-item, .js-slider-pager-item')
            .forEach(item => {
              item.classList.remove('is-hide');
              if (item.classList.contains('is-active')) {
                item.classList.add('is-hide');
                setTimeout(() => {
                  item.classList.remove('is-hide');
                }, 430);
              }
              item.classList.remove('is-active');
            });
          container
            .querySelectorAll('.js-slider-item')
            [[...pager.children].indexOf(e.target)].classList.add('is-active');
          e.target.classList.add('is-active');
        });
      });
    }

    const checkAndSlide = (activeIndex, sideShow) => {
      if (activeIndex < 0) {
        activeIndex = [...sliderItems].length - 1;
      } else if (activeIndex > [...sliderItems].length - 1) {
        activeIndex = 0;
      }
      [...sliderItems].forEach((slide, index) => {
        if (index === activeIndex) {
          if (sideShow === 'left') {
            slide.classList.add('left');
          } else {
            slide.classList.add('right');
          }
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });
    };

    container.querySelectorAll('.js-arrow').forEach(btn => {
      btn.addEventListener('click', e => {
        [...sliderItems].forEach(slide => {
          slide.classList.remove('left', 'right');
        });
        const activeElement = container.querySelector(
          '.js-slider-item.is-active',
        );
        let sideShow = 'right';
        let activeIndex = [...sliderItems].indexOf(activeElement);
        if (e.currentTarget.classList.contains('js-arrow-prev')) {
          activeIndex -= 1;
          sideShow = 'left';
        } else {
          activeIndex += 1;
          sideShow = 'right';
        }

        checkAndSlide(activeIndex, sideShow);
      });
    });
    const getTouches = evt => evt.touches || evt.originalEvent.touches;

    const handleTouchStart = evt => {
      const firstTouch = getTouches(evt)[0];
      xDown = firstTouch.clientX;
      yDown = firstTouch.clientY;
    };

    const handleTouchMove = evt => {
      if (!xDown || !yDown) {
        return;
      }

      const xUp = evt.touches[0].clientX;
      const yUp = evt.touches[0].clientY;
      const xDiff = xDown - xUp;
      const yDiff = yDown - yUp;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        const activeElement = container.querySelector(
          '.js-slider-item.is-active',
        );
        let sideShow = 'right';
        let activeIndex = [...sliderItems].indexOf(activeElement);
        if (xDiff > 0) {
          activeIndex += 1;
          sideShow = 'right';
        } else {
          activeIndex -= 1;
          sideShow = 'left';
        }

        checkAndSlide(activeIndex, sideShow);
        if (pager) {
          const pages = pager.querySelectorAll('.js-slider-pager-item');
          pages.forEach(page => {
            page.classList.remove('is-active');
          });
          pages[activeIndex].classList.add('is-active');
        }
      }

      xDown = null;
      yDown = null;
    };

    sliderItems.forEach(item => {
      item.addEventListener('touchstart', handleTouchStart, { passive: true });
      item.addEventListener('touchmove', handleTouchMove, { passive: true });
    });
  });
};

export default slider;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/slider.js